<template>
<div class="subtabs ">
<div class="mdc-tab-bar main-tabs" role="tablist" id="examListTab">
	<div class="mdc-tab-scroller ">
		<div class="mdc-tab-scroller__scroll-area">
			<div class="mdc-tab-scroller__scroll-content justify-content-center">
				<button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="moveTab('total')">
						<span class="mdc-tab__content">
							<span class="mdc-tab__text-label font-m t-body2">{{$t('996')}}</span>
						</span>
						<span class="mdc-tab-indicator mdc-tab-indicator--active">
								<span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
						</span>
						<span class="mdc-tab__ripple"></span>
				</button>
				<button class="mdc-tab " role="tab" tabindex="0" @click="moveTab('my')">
						<span class="mdc-tab__content">
								<span class="mdc-tab__text-label font-m t-body2">{{$t('997')}}</span>
						</span>
						<span class="mdc-tab-indicator ">
								<span
										class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
						</span>
						<span class="mdc-tab__ripple"></span>
				</button>
				<button class="mdc-tab " role="tab" tabindex="0" @click="moveTab('result')">
						<span class="mdc-tab__content">
								<span class="mdc-tab__text-label font-m t-body2">{{$t('998')}}</span>
						</span>
						<span class="mdc-tab-indicator ">
								<span
										class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
						</span>
						<span class="mdc-tab__ripple"></span>
				</button>
			</div>
		</div>
	</div>
</div>
<div class="divider divider-subtabs"></div>
</div>
</template>


<script>
/**
 * 단독 시험 목록 텝 컴포넌트(indepandent exam list tab Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
	data() {
		return {
			tabBar: null
		}
	},
	watch:{
		$route (to, from){
			this.setTabActive()
		}
	},
	mounted() {
		this.tabBar = new MDCTabBar(document.querySelector('#examListTab'))
		this.setTabActive()
	},

	methods: {
		setTabActive() {
			let status = this.$route.query.listType

			if (status === 'total') {
				this.tabBar.activateTab(0)
			}else if (status === 'my') {
				this.tabBar.activateTab(1)
			}else if (status === 'result') {
				this.tabBar.activateTab(2)
			}else {
				this.tabBar.activateTab(0)
			}

			
		},

		moveTab(type) {
			const loginPath = `/login?redirectPath=${encodeURIComponent(this.$route.fullPath)}`
			if (!localStorage.getItem('token')) {
				this.$router.push(loginPath)
			}else {
				this.$router.push({name: 'IndependentExam', query: {listType: type}}) 
			}
		}
		
	}

}
</script>
